module.exports = __webpack_public_path__ + "img/treatment-history-section-ru.13aee5df.jpg";